import { informationPopupApi } from '../api/informationPopupApi';
import { configPromise } from 'config';
import { InformationPopupDataManagementModel } from '../models/informationPopup/InformationPopupDataManagementModel';

class InformationPopupAction {

  /**
   * @param {INFORMATION_POPUP_CONTEXT_CODES} code
   * @return {Promise<InformationPopupDataManagementModel>}
   */
  async getPopupContent(code) {
    const popupDataModel = await informationPopupApi.getContentUrl(code);
    const popupDataManagementModel = new InformationPopupDataManagementModel(popupDataModel);
    return popupDataManagementModel;
  }

  /**
   * @param {InformationPopupDataModel} dataModel
   * @return {Promise<*>}
   */
  dismissPopup(dataModel) {
    const model = { ...dataModel, isHidden: true };
    return informationPopupApi.savePopupStatus(model);
  }

  /**
   * @param {string} contentUrl
   * @return {Promise<{ success: boolean }>}
   */
  async validatePopupContent(contentUrl) {
    return new Promise(resolve => {
      $.get(contentUrl)
        .done(() => resolve({ success: true }))
        .fail(() => resolve({ success: false }));
    });
  }

}
export const informationPopupAction = new InformationPopupAction();
